"use struct";

export function ga_registration(){
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'registration', '2-2.会員登録ボタン', '/register.php?from=%2Faccount%2Fmembership%2Fpayment%3Fplan%3D1&c-ms-mode=2');
  }
}
